__turbopack_context__.v({
  "className": "-SApsq_className",
  "variable": "-SApsq_variable",
});
